import {
  View,
  Text,
  StyleSheet,
} from "react-native";
import React, { useEffect } from "react";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";

import { useTranslation } from "react-i18next";
import SyncStatusIndicator from "../../Components/SyncStatusIndicator";
import WorkoutLibrary from "./WorkoutLibrary";
import ExerciseLibrary from "./ExerciseLibrary";
import BlockLibrary from "./BlockLibrary";
import ModifierLibrary from "./ModifierLibrary";
import { useScreenDimensions } from "../../_layout";
import FormLibrary from "./FormLibrary";
import LogoImage from "../../Components/LogoImage";
import { getHeaderLogoMaxWidth } from "../../Components/logoImageHeaderSizing";
import { observer } from "mobx-react";
import GlobalExerciseSearchFloating from "../../Exercise/Search/GlobalExerciseSearchFloating";
import UnifiedTabBar from "../../Components/UnifiedTabBar";

const CoachLibrary = observer(({ coach }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const headerLogoMaxWidth = getHeaderLogoMaxWidth(screenSize);
  const selectedTab = coach.librarySelectedTab;

  const TabOptions = [
    {
      key: "forms-string",
      label: t("forms-string"),
    },
    {
      key: "blocks-string",
      label: t("blocks-string"),
    },
    {
      key: "workouts-string",
      label: t("workouts-string"),
    },
    {
      key: "exercises-string",
      label: t("exercises-string"),
    },
    {
      key: "modifiers-string",
      label: t("modifiers-string"),
    },
  ];

  const components = {
    "forms-string": FormLibrary,
    "blocks-string": BlockLibrary,
    "workouts-string": WorkoutLibrary,
    "exercises-string": ExerciseLibrary,
    "modifiers-string": ModifierLibrary,
  };

  const ComponentToShow = components[selectedTab] || null;

  useEffect(() => {
    coach.setProperty("searchTermFormLibrary", "");
    coach.setProperty("searchTermBlockLibrary", "");
    coach.setProperty("searchTermWorkoutLibrary", "");
    coach.setProperty("searchTermPred", "");
    coach.setProperty("searchTermAttr", "");
  }, []);

  return (
    <View style={styles.container}>
      <View>
        <View
          style={[GlobalStyles.HStack, { width: "100%", alignItems: "center" }]}
        >
          <Text
            style={[
              Fonts.bold24,
              { marginRight: screenSize === "small" ? 8 : 12, fontWeight: "600" },
            ]}
          >
            {t("library-string")}
          </Text>
          <SyncStatusIndicator
            syncStatusManager={coach.syncStatusManager}
            onPress={() => coach.startOrResetBatchTimer()}
          />
          <View style={{ flex: 1 }} />

          <LogoImage coach={coach} maxWidth={headerLogoMaxWidth} />
        </View>

        {coach && (
          <UnifiedTabBar
            tabs={TabOptions.map((option) => ({
              key: option.key,
              label: option.label,
            }))}
            selectedKey={selectedTab}
            onSelect={(key) => coach.setProperty("librarySelectedTab", key)}
            topMargin={24}
            itemGap={screenSize === "small" ? 12 : 24}
          />
        )}
        {ComponentToShow && <ComponentToShow coach={coach} />}
      </View>
      
      {/* Global floating search - single instance for all exercises and slots */}
      <GlobalExerciseSearchFloating />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
});

export default CoachLibrary;
